import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (credentials) => api.post("/auth/login", credentials),
  register: (data) => api.post("/auth/register", data),
  getMe: () => api.get("/auth/me"),
};

// Children API
export const childrenAPI = {
  list: () => api.get("/children"),
  get: (id) => api.get(`/children/${id}`),
  create: (data) => api.post("/children", data),
  update: (id, data) => api.put(`/children/${id}`, data),
  delete: (id) => api.delete(`/children/${id}`),
  verify: (data) => api.post("/verify-child", data),
  publicRegister: (data) => api.post("/public/register-child", data),
};

// Workshops API
export const workshopsAPI = {
  list: (params) => api.get("/workshops", { params }),
  get: (id) => api.get(`/workshops/${id}`),
  create: (data) => api.post("/workshops", data),
  update: (id, data) => api.put(`/workshops/${id}`, data),
  delete: (id) => api.delete(`/workshops/${id}`),
};

// Bookings API
export const bookingsAPI = {
  list: () => api.get("/bookings"),
  listByWorkshop: (workshopId) => api.get(`/bookings/by-workshop/${workshopId}`),
  create: (data) => api.post("/bookings", data),
  delete: (id) => api.delete(`/bookings/${id}`),
  resendWhatsapp: (id) => api.post(`/bookings/${id}/resend-whatsapp`),
};

// Reminders API
export const remindersAPI = {
  getUnscheduledCount: () => api.get("/reminders/unscheduled-count"),
  sendReminders: (data) => api.post("/reminders/send-unscheduled", data),
  getReminderStatus: (jobId) => api.get(`/reminders/status/${jobId}`),
  getHistory: () => api.get("/reminders/history"),
};

// Stats API
export const statsAPI = {
  get: () => api.get("/stats"),
};

export default api;
